// extracted by mini-css-extract-plugin
export default {"footer_buttons_container":"footer_buttons_container_j_m6VBnv","footer_buttons_drawer_list":"footer_buttons_drawer_list_fcQ6ljQM"};